import React from 'react'
import { List } from 'reactstrap'
import PropTypes from 'prop-types'
import { v1 as uuidv1 } from 'uuid'
import { useTranslation } from 'react-i18next'

const ValueDisplay = ({ value = null }) => {
  const { t } = useTranslation('commons')

  const EmptyValueComponent = (
    <i className="text-muted">{t('global.empty')}</i>
  )

  const SpacedValueComponent = (
    <i className="text-muted">{t('global.space')}</i>
  )

  const NullValueComponent = (
    <i className="text-muted">{t('global.null')}</i>
  )

  const UnknownValueComponent = (
    <i className="text-muted">{t('global.unknown')}</i>
  )

  const renderValue = (stringValue) => {
    if (Array.isArray(stringValue)) {
      return (
        <List type="unstyled" className="mb-0">
          {stringValue.map((item) => (
            <li key={uuidv1()}>{renderValue(item)}</li>
          ))}
        </List>
      )
    }

    if (typeof stringValue === 'string' && stringValue !== null) {
      if (stringValue.match(/^\s+$/)) return SpacedValueComponent
      return stringValue || EmptyValueComponent
    }

    if (typeof stringValue === 'number') return stringValue.toString()

    if (typeof stringValue === 'boolean') return stringValue.toString()

    if (stringValue === null) return NullValueComponent

    if (typeof stringValue === 'object') {
      return JSON.stringify(stringValue)
    }

    return UnknownValueComponent
  }

  return <>{renderValue(value)}</>
}

ValueDisplay.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.object,
    PropTypes.string
  ])
}

export default ValueDisplay
